/**
 * "← Back" pill used at the top of every registration step (except step 1).
 * Native button rather than a Link because moving between steps mutates
 * internal state, not the URL.
 */
type BackLinkProps = {
  onClick: () => void;
  label?: string;
  /** Pass the step's `busy` flag so back-navigation can't race a pending
   *  API request or an in-flight step transition. */
  disabled?: boolean;
};

export function BackLink({ onClick, label = 'Back', disabled }: BackLinkProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="group inline-flex items-center gap-[10px] self-start font-['Arial',sans-serif] text-[18px] text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#3a2f44] disabled:cursor-not-allowed disabled:opacity-50"
    >
      <span className="flex h-[30px] w-[30px] items-center justify-center rounded-full border border-white/80 transition-colors group-hover:border-[#00ffb2] group-hover:text-[#00ffb2] group-disabled:border-white/80 group-disabled:text-white">
        <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 12H5" />
          <path d="M12 19l-7-7 7-7" />
        </svg>
      </span>
      <span className="transition-colors group-hover:text-[#00ffb2] group-disabled:text-white">{label}</span>
    </button>
  );
}
